import { IconDownload, IconExclamationCircle } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Accordion, Button } from 'react-bootstrap';
import { downloadCSV } from '../../Utils/helpers/commonhelper';
import { Loader } from './Loader';
import Select from "react-select"
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../../Utils/constants/constant';
import { PostRequest } from '../../Utils/hooks/ApiHandler';
import { toast } from 'sonner';
import CsvDownloader from "react-csv-downloader";
export const ImportStep3 = ({
    data,
    customer,
    loading,
    setLoading,
    extras,
    headers,
    fileHeaders,
    importResult,
    unmappedCount,
    currentSelected,
    setCurrStep
}) => {
    const navigate = useNavigate()
    const navigateWithModuleName = () => {
        switch (data?.module_name) {
            case "company":
                return "company";
            case "contact":
                return "contacts";
            case "leads":
                return "leads";
            case "deals":
                return "deals";
            case "quotation":
                return "quotations";
            case "purchase_order":
                return "purchaseorder";
            case "sales_order":
                return "salesorder";
            case "invoice":
                return "salesorder?type=invoice";
            case "invoice_order":
                return "salesorder?type=invoice";
            case "invoice_order":
                return "salesorder?type=invoice";
            case "master_product":
                return "product";
            case "lead_source":
                return "enquirySource";
            case "department":
                return "department";
            case "designation":
                return "designation";
            default:
                return "";
        }
    };
    const [overwriteColumn, setOverwriteColumn] = useState(null);

    // Final import function
    const handleFinalImport = async () => {
        setLoading(true);
        try {
            const payload = {
                customer_id: customer.customer_details?.customer_id,
                user_login_id: customer.customer_details?.id,
                module_name: data?.module_name,
                action:
                    data?.module_name === "contact" || data?.module_name === "company"
                        ? currentSelected
                        : "insert",
                labels: importResult?.label || [],
                values: importResult?.importing_data || [],
                overwrite_value: overwriteColumn
            };

            const res = await PostRequest(
                `${baseURL}csv/importData/`,
                payload,
                false,
                { headers },
                extras
            );
            toast.success(res.message);
            // forcing the page to refresh to get the updated data
            window.open(`${baseURL}${navigateWithModuleName()}`, "_self");

        } catch (error) {
            console.error("Final import failed", error);
            toast.error("Import failed!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div
                    className="mx-auto"
                    style={{ minWidth: "900px", maxWidth: "900px" }}
                >
                    <div
                        className="d-flex align-items-center gap-2 mb-4 p-3"
                        style={{
                            backgroundColor: "#fff8e1",
                            borderLeft: "4px solid #ffb300",
                            borderRadius: "4px",
                            color: "#8a6d3b",
                        }}
                    >
                        {currentSelected === "skip" ? (
                            <>
                                <IconExclamationCircle size={18} />
                                <span className="fs-14 fw-500">
                                    Data will be skipped on the basis of Email and Phone
                                    Number.
                                </span>
                            </>
                        ) : (
                            <>
                                <div className="d-flex flex-column w-100">
                                    <span className="fs-14 fw-500 mb-2 d-flex align-items-center gap-1 justify-content-start ">
                                        <IconExclamationCircle size={18} />
                                        Overwrite will occur based on the selected matching
                                        column.
                                    </span>
                                    <Select
                                        options={fileHeaders.map((h) => ({
                                            value: h.value?.toLowerCase(),
                                            label: h.label,
                                        }))}
                                        placeholder="Select matching column..."
                                        styles={{
                                            placeholder: (base) => ({
                                                ...base,
                                                marginLeft: "10px",
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                marginLeft: "10px",
                                            }),
                                            control: (base) => ({
                                                ...base,
                                                width: "425px",
                                                minHeight: "36px",
                                                borderRadius: "6px",
                                                border: "1px solid #e2e8f0",
                                                boxShadow: "none",
                                                fontSize: "13px",
                                                "&:hover": { borderColor: "#cbd5e0" },
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                width: "425px",
                                                fontSize: "13px",
                                                zIndex: 9999,
                                                maxHeight: "10rem",
                                                overflow: "auto",
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                color: "black",
                                            }),
                                        }}
                                        onChange={(selected) =>
                                            setOverwriteColumn(selected?.value)
                                        }
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <h4 className="mb-3">Preview</h4>

                    <Accordion defaultActiveKey={["0"]} alwaysOpen>
                        <Accordion.Item
                            className="sales-order-accordion"
                            eventKey="0"
                        >
                            <Accordion.Header>
                                {importResult?.importing_data?.length > 0 && (
                                    <i className="bi bi-exclamation-circle-fill text-warning me-2"></i>
                                )}
                                Imported Data
                            </Accordion.Header>
                            <Accordion.Body>
                                {importResult?.importing_data?.length > 0 ? (
                                    <div className="importPreviewScroll">
                                        <table
                                            className="table table-bordered"
                                            style={{ minWidth: "600px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    {importResult?.label?.map((lbl) => (
                                                        <th
                                                            key={lbl}
                                                            style={{ textTransform: "capitalize" }}
                                                        >
                                                            {lbl.replace(/_/g, " ")}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {importResult?.importing_data?.map((row, idx) => (
                                                    <tr key={idx}>
                                                        {row?.map((col, i) => (
                                                            <td key={i}>{col}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No imported data available.</p>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item
                            className="sales-order-accordion"
                            eventKey="1"
                        >
                            <Accordion.Header>
                                <div className="d-flex align-items-center gap-2 w-100 justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        {importResult?.skipped_data?.length > 0 && (
                                            <i className="bi bi-exclamation-circle-fill text-warning me-2"></i>
                                        )}
                                        Skipped Data -{" "}
                                        <span style={{ fontSize: "14px", fontWeight: 500, color: "#ffbd06" }}>
                                            {importResult?.skipped_data?.length || 0}
                                        </span>
                                    </div>

                                    {importResult?.skipped_data?.length > 0 && (
                                        <span
                                            className="text-primary d-flex align-items-center"
                                            style={{
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                                marginRight: "1rem",
                                            }}
                                            disabled={importResult?.skipped_data?.length > 0}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                downloadCSV(
                                                    data?.module_name,
                                                    importResult?.skipped_data
                                                );
                                            }}
                                        >
                                            <IconDownload size={16} stroke={2} />
                                            Download CSV
                                        </span>
                                    )}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body style={{ maxHeight: "8rem", overflow: "scroll", scrollBehavior: 'smooth' }} className='listStyleForContact'>
                                {importResult?.skipped_data?.length > 0 ? (
                                    <div className="importPreviewScroll">
                                        <table
                                            className="table table-bordered"
                                            style={{ minWidth: "600px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    {importResult.label?.map((lbl) => (
                                                        <th
                                                            key={lbl}
                                                            style={{ textTransform: "capitalize" }}
                                                        >
                                                            {lbl.replace(/_/g, " ")}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {importResult.skipped_data?.map((row, idx) => (
                                                    <tr key={idx}>
                                                        {row.map((col, i) => (
                                                            <td key={i}>{col}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No skipped rows available.</p>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item
                            className="sales-order-accordion"
                            eventKey="2"
                        >
                            <Accordion.Header className='d-flex justify-content-between align-items-center'>
                                <div className="d-flex align-items-center gap-2 w-100 justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        {importResult?.reject?.length > 0 && (
                                            <i className="bi bi-exclamation-circle-fill text-warning px-1"></i>
                                        )}
                                        <span>Rejected Data -{" "}</span>
                                        <span style={{ fontSize: "14px", fontWeight: 500, color: "#ffbd06" }}>
                                            {importResult?.reject?.length || 0}
                                        </span>
                                    </div>

                                    {importResult?.reject?.length > 0 && (
                                        <CsvDownloader
                                            filename={`${data?.module_name}_rejected`}
                                            extension=".csv"
                                            separator=","
                                            columns={importResult.labels}
                                            datas={importResult.reject}
                                            style={{
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                                marginRight: "1rem",
                                            }}
                                            className="text-primary d-flex align-items-center"
                                        >
                                            <IconDownload size={16} stroke={2} />
                                            Download CSV
                                        </CsvDownloader>
                                    )}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body >
                                {importResult?.reject?.length > 0 ? (
                                    <div className="importPreviewScroll">
                                        <table
                                            className="table table-bordered "
                                            style={{ minWidth: "800px", }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>REJECT REASON</th>
                                                    {importResult.label?.map((lbl) => (
                                                        <th
                                                            key={lbl}
                                                            style={{ textTransform: "capitalize" }}
                                                        >
                                                            {lbl.replace(/_/g, " ")}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {importResult.reject?.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>{row[row.length - 1]}</td>
                                                        {row.slice(0, -1).map((col, i) => (
                                                            <td key={i}>{col}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No rejected rows.</p>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item
                            className="sales-order-accordion"
                            eventKey="3"
                        >
                            <Accordion.Header>
                                <div className="d-flex align-items-center gap-2">
                                    <span>
                                        <i className="bi bi-exclamation-triangle-fill text-warning px-1"></i>{" "}
                                        Unmapped Fields -{" "}
                                    </span>
                                    <p style={{ fontWeight: 500, color: "#ffbd06" }}>
                                        {unmappedCount}
                                    </p>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                {importResult?.unmapped?.length > 0 ? (
                                    <pre>
                                        {JSON.stringify(importResult.unmapped, null, 2)}
                                    </pre>
                                ) : (
                                    <p>No unmapped fields.</p>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion >

                    <div className="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                        <Button
                            className="px-4 fs-14 btn btn-default"
                            onClick={() => setCurrStep(2)}
                        >
                            Previous Step
                        </Button>
                        <div className="d-flex gap-2">
                            <Button
                                onClick={() => setCurrStep(1)}
                                className="text-muted btn btn-default-outline text-decoration-none fs-14">
                                Cancel
                            </Button>
                            <Button
                                className="px-5 fs-14 fw-500 btn btn-default"
                                disabled={!importResult?.importing_data?.length}
                                onClick={async () => {
                                    await handleFinalImport();
                                }}
                            >
                                Import
                            </Button>
                        </div>
                    </div>
                </div >
            )}
            <style>
                {`
                .importPreviewScroll {
                    max-height: 28rem;
                    overflow: auto;
                }

                .importPreviewScroll::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }

                .importPreviewScroll::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                }

                .importPreviewScroll::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }
                `}
            </style>
        </>
    )
}
